import { Paperclip } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useReceiveAttachmentDownload, type ReceiveAttachmentDto } from '@/entities/receive';

interface ReceiveHistoryAttachmentsCellProps {
  attachments: ReceiveAttachmentDto[];
}

/**
 * Documents of one receipt, as download links.
 *
 * A component rather than plain JSX in the column definition: the download needs
 * a hook, and keeping it here leaves `getReceiveHistoryColumns` a pure function
 * of `t`, with no callbacks threaded through the page.
 */
export function ReceiveHistoryAttachmentsCell({ attachments }: ReceiveHistoryAttachmentsCellProps) {
  const { download } = useReceiveAttachmentDownload();

  return (
    <div className="flex flex-col items-start gap-1">
      {attachments.map((attachment) => (
        <Button
          key={`${attachment.shipmentId}-${attachment.id}`}
          type="button"
          variant="link"
          size="sm"
          className="h-auto max-w-[240px] justify-start p-0 text-left"
          onClick={() => download(attachment)}
          title={attachment.fileName}>
          <Paperclip className="h-3 w-3 shrink-0" />
          <span className="truncate">{attachment.fileName}</span>
        </Button>
      ))}
    </div>
  );
}
